import { render, staticRenderFns } from "./magazineList.vue?vue&type=template&id=68db0b27"
import script from "./magazineList.vue?vue&type=script&lang=js"
export * from "./magazineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports